export default {"src":"__ASTRO_ASSET_IMAGE__DN_dqhS5__","width":72,"height":72,"format":"webp"}